/*
 * Collapsed Item component for pop up window
 * Author: Chris
 * CreatedAt: 2021-4-1
 */

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { ContentCard, Uploader } from '@/src/components';
import {
  Collapse,
  Input, //Radio
} from '@/src/components/Antd';
import {
  checkDuplicatedName,
  getCollapseOpenStatus,
  getPopUpWindowData,
  onCollapseOpen,
  onDeletePopUpWindow,
  onDuplicatePopUpWindow,
} from '@/src/pages/SalesChannelContentEditor/SalesChannelEditorPromotion/redux';
import { IPopUpWindow } from '@/src/types/common/SalesChannel';
import _ from 'lodash';
import { ErrorDisplay } from 'src/constrains/SalesChannelPreviewPageComponents/CollapseErrors';
import GeneralCollapseContent from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseContent';
import GeneralCollapseWrapper from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseWrapper';
import ItemWrapper from 'src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from 'src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import PreviewWrapper from 'src/pages/SalesChannelContentEditor/SalesChannelEditorPromotion/Preview/Wrapper';
import Select from '../../../../../components/Antd/Select/Select';
import { EnumPromotionPopWindowType } from '../../common';
// import { getSalesChannelTimezoneGmt } from '@/src/constrains/SalesChannelHOC/slice';
import { errCodesMap } from '@/src/error/code';
import { modal } from '@/src/utils/Modal';
import { get } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  i18nGet,
  handleOnFormatCurrentSCTimeAndDate,
  handleOnGetCurrentSCDateFormat,
} from 'src/tools/tools';
import { validationSingle } from '../../validation';
import css from './CollapseItem.less';
import { useParams /*useLocation,*/ } from 'react-router-dom';
import LinkLibraryWithSisterScScope from 'src/constrains/LinkLibrary/LinkLibraryWithSisterScScope';

interface IProps {
  editable: boolean;
  shouldShowErrors: boolean;
  data: IPopUpWindow;
  onChange: (type: string, data: any) => void;
  onOpenCollapse: (status: boolean) => void;
  linkSet: any;
  isPrimary?: boolean;
  withoutCollapse?: boolean;
  scTimezoneUTC: string;
  disabled?: boolean;
}

const CollapseItem = ({
  editable,
  shouldShowErrors,
  data,
  onChange,
  onOpenCollapse,
  linkSet,
  isPrimary,
  withoutCollapse,
  scTimezoneUTC,
  disabled,
}: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [fileList, setFileList] = useState([]);
  //const [error, setError] = useState(false);
  const [radioValue, setRadioValue] = useState(
    EnumPromotionPopWindowType.ImageAndLink,
  );
  const _params: any = useParams();
  const { contentUuid } = _params;
  const { linkTypeFilter } = linkSet || {};
  const { id, remark, linkTo } = data;
  // const timezoneGmt = useSelector(getSalesChannelTimezoneGmt());

  const _open = useSelector(getCollapseOpenStatus(id));

  const popupWindows = useSelector(getPopUpWindowData());

  const _d = useDispatch();

  useEffect(() => {
    if (data.image) {
      setFileList([data.image]);
    }

    //setError(!checkPopUpWindowError(data));
  }, [data]);

  const isRemarkDuplicated = useSelector(checkDuplicatedName(data.remark, id));

  const handleOpenCollapse = (status) => {
    const openIds = status ? [id] : [];
    _d(onCollapseOpen({ idArr: openIds }));

    if (onOpenCollapse) {
      onOpenCollapse(status);
    }
  };

  const handleInputBlur = () => {
    return null;
  };

  const handleChange = (type, value) => {
    if (type === 'remark') {
      onChange(type, { ...data, remark: value, id });
    } else if (type === 'date') {
      onChange(type, { id });
    } else if (type === 'radio') {
      const { value: radioValue } = value.target;
      setRadioValue(radioValue);
      onChange(type, { id, promotionType: radioValue });
    } else if (type === 'image') {
      const image = value.length ? value[value.length - 1] : {};
      onChange(type, {
        id,
        image,
      });
    } else if (type === 'link') {
      onChange(type, {
        id,
        linkTo: value,
      });
    } else if (type === 'frequency-input') {
      onChange('frequency', {
        id,
        displayFrequency: {
          ...data.displayFrequency,
          frequency: value,
        },
      });
    } else if (type === 'frequency-select') {
      onChange('frequency', {
        id,
        displayFrequency: {
          ...data.displayFrequency,
          basedOn: value === 'Visit' ? 'Visit' : 'Period', //"Period",
          periodUnit: value === 'Visit' ? null : value, //"Day"
        },
      });
    }
  };

  const onDuplicate = () => {
    _d(onDuplicatePopUpWindow({ id }));
  };
  const onDeleteItem = () => {
    _d(onDeletePopUpWindow({ id }));
  };

  const getMoreOptions = () => {
    return [
      {
        key: 'duplicate',
        body: getI18n('general.duplicate'),
        onClick: onDuplicate.bind(this, 'id'),
      },
      {
        key: 'delete',
        body: getI18n('general.delete'),
        onClick: () =>
          modal.error({
            title: getI18n(
              'salesChannelContent.index.deletePopupWindowPromotion',
            ),
            content: getI18n(
              'salesChannelContent.index.deletePopupWindowPromotionContent',
            ),
            onOkText: getI18n('general.delete'),
            onCancelText: getI18n('general.cancel'),
            onOk: onDeleteItem.bind(this, 'id'),
            onCancel: () => console.log('cancel'),
          }),
      },
    ];
  };

  const renderTitle = () => {
    let date = '';
    const dateFormat = handleOnGetCurrentSCDateFormat();
    if (data && data.beginDate) {
      const begin = moment(data.beginDate).format(dateFormat);
      let end;
      if (!data.endDate) {
        end = '';
      } else {
        end = moment(data.endDate).format(dateFormat);
      }
      date = `${begin} - ${end}`;
    }

    let title = date;
    if (shouldShowErrors) {
      if (!date.length) {
        title = getI18n('general.moduleListError.999977');
      }
    } else {
      if (!date.length) {
        title = getI18n('salesChannelContent.index.pleasesetstartandendtime');
      }
    }

    const titleColor =
      title === getI18n('general.moduleListError.999977')
        ? '#FF695F'
        : editable
        ? '#38C568'
        : '#B0B0B0';
    const errs = getErrorList();
    const { hasError } = errs;
    return (
      <ContentCard
        hideDots={!isPrimary}
        title={title}
        titleColor={titleColor}
        content={remark}
        err={shouldShowErrors ? hasError : false}
        dotsFunctions={getMoreOptions()}
      />
    );
  };

  const getErrorList = () => {
    const errors = validationSingle(data, popupWindows, isPrimary);
    return {
      hasError: errors.hasError,
      errors: Array.from(new Set(errors.errors)),
    };
  };

  const Error = (display: boolean, open: boolean, err: any) => {
    if (display) {
      return (
        <ErrorDisplay
          open={open}
          err={err.map((er: any) => (errCodesMap[er] ? errCodesMap[er] : er))}
        />
      );
    } else {
      return null;
    }
  };

  return (
    <GeneralCollapseWrapper>
      <Collapse
        id={id}
        open={_open}
        title={renderTitle()}
        err={Error(shouldShowErrors, _open, getErrorList().errors)}
        content={
          <GeneralCollapseContent>
            {isPrimary && (
              <Section bottomBorder className={css.section}>
                <div className={css.title}>
                  <span>
                    {getI18n('salesChannelContent.index.nameforinternaluse')}
                  </span>
                  {editable && (
                    <span className={css.desc}>{`${_.get(
                      remark,
                      'length',
                      0,
                    )}/100`}</span>
                  )}
                </div>
                <div className={css.input}>
                  {editable ? (
                    <>
                      <Input
                        style={{
                          border: isRemarkDuplicated
                            ? 'solid 1px #ff695f'
                            : undefined,
                        }}
                        size='large'
                        disabled={!editable}
                        value={remark}
                        onChange={(v) => handleChange('remark', v)}
                        onBlur={handleInputBlur}
                        maxLength={100}
                      />
                      {isRemarkDuplicated && (
                        <div className={css.duplicatedError}>
                          {getI18n('salesChannelContent.index.duplicatedError')}
                        </div>
                      )}
                    </>
                  ) : (
                    <span>{remark}</span>
                  )}
                </div>
              </Section>
            )}

            <div className={css.flex}>
              <div className={css.left}>
                {isPrimary && (
                  <Section bottomBorder className={css.section}>
                    <div className={css.timeDisplay}>
                      <div className={css.title}>{`${getI18n(
                        'general.startTime',
                      )} (UTC ${scTimezoneUTC})`}</div>
                      <div className={css.time}>
                        {data.beginDate && data.beginTime
                          ? handleOnFormatCurrentSCTimeAndDate(
                              `${data.beginDate} ${data.beginTime}`,
                            )
                          : '-'}
                      </div>
                    </div>
                    <div className={css.timeDisplay}>
                      <div className={css.title}>{`${getI18n(
                        'general.endTime',
                      )} (UTC ${scTimezoneUTC})`}</div>
                      <div className={css.time}>
                        {data.endDate && data.endTime
                          ? handleOnFormatCurrentSCTimeAndDate(
                              `${data.endDate} ${data.endTime}`,
                            )
                          : '-'}
                      </div>
                    </div>
                    {editable && (
                      <div
                        className={css.timeSetting}
                        onClick={() => handleChange('date', '')}>
                        {getI18n(
                          'salesChannelContent.index.editStartandEndTime',
                        )}
                      </div>
                    )}
                  </Section>
                )}

                {/* {isPrimary && editable && (
                  <Section bottomBorder className={css.section}>
                    <div className={css.title}>Popup Window Type</div>
                    <div className={css.radio}>
                      <Radio
                        value={
                          data.promotionType ||
                          EnumPromotionPopWindowType.ImageAndLink
                        }
                        onChange={(v) => handleChange('radio', v)}
                        radioList={[
                          {
                            value: EnumPromotionPopWindowType.ImageAndLink,
                            disable: false,
                            label: 'Image and Link',
                          },
                          // {
                          //   value: EnumPromotionPopWindowType.EDM,
                          //   disable: false,
                          //   label: 'EDM (Electronic Direct Mail)',
                          // },
                        ]}
                      />
                    </div>
                  </Section>
                )} */}

                {radioValue === EnumPromotionPopWindowType.ImageAndLink && (
                  <Section bottomBorder>
                    <ItemWrapper
                      title={getI18n('general.checkImgDraggableDisplay.title')}
                      bottomTitle={`${getI18n(
                        'general.upload.EditModal.ratio',
                      )} 7:8`}>
                      <Uploader
                        type={'Image'}
                        disabled={!editable || disabled}
                        multiple={false}
                        height={180}
                        fileList={fileList}
                        onChange={(v) => handleChange('image', v)}
                        hideEdit={!editable}
                      />
                    </ItemWrapper>

                    <ItemWrapper>
                      {editable ? (
                        <LinkLibraryWithSisterScScope
                          disabled={!editable || disabled}
                          title={getI18n('general.linkModule.Modal.link')}
                          data={linkTo}
                          onChange={(v) => handleChange('link', v)}
                          salesChannelContentUuid={contentUuid}
                          presetLinkTypeFilter={linkTypeFilter}
                        />
                      ) : (
                        <ItemWrapper
                          title={getI18n('general.linkModule.Modal.link')}>
                          <span>{get(linkTo, 'label')}</span>
                        </ItemWrapper>
                      )}
                    </ItemWrapper>
                  </Section>
                )}
                {isPrimary && (
                  <Section bottomBorder>
                    <ItemWrapper
                      title={getI18n(
                        'salesChannelContent.index.displayFrequency',
                      )}>
                      <div className={css.frequencyContainer}>
                        <div className={css.frequencySubtitle}>
                          {getI18n(
                            'salesChannelContent.index.displayOnceEvery',
                          )}
                          {!editable &&
                            ` ${data.displayFrequency?.frequency || 0} ${
                              data.displayFrequency?.basedOn !== 'Visit'
                                ? data.displayFrequency?.periodUnit
                                : data.displayFrequency?.basedOn
                            }s`}
                        </div>
                        {editable && (
                          <div className={css.frequencyBody}>
                            <Input
                              size='large'
                              disabled={!editable}
                              className={css.frequencyInput}
                              value={
                                data.displayFrequency?.frequency === undefined
                                  ? '2'
                                  : data.displayFrequency?.frequency
                              }
                              onChange={(v) =>
                                handleChange('frequency-input', v)
                              }
                            />

                            <Select
                              size={'large'}
                              selectClassName={css.frequencySelect}
                              placeholder={getI18n(
                                'salesChannelContent.index.visits',
                              )}
                              disabled={!editable}
                              value={
                                data.displayFrequency?.basedOn !== 'Visit'
                                  ? data.displayFrequency?.periodUnit
                                  : data.displayFrequency?.basedOn
                              }
                              optionsList={[
                                {
                                  label: getI18n(
                                    'salesChannelContent.index.visits',
                                  ),
                                  value: 'Visit',
                                },
                                {
                                  label: getI18n('general.commonDate.day(s)'),
                                  value: 'Day',
                                },
                                {
                                  label: getI18n(
                                    'salesChannelContent.index.hours',
                                  ),
                                  value: 'Hour',
                                },
                                {
                                  label: getI18n(
                                    'salesChannelContent.index.minutes',
                                  ),
                                  value: 'Minute',
                                },
                              ]}
                              onChange={(v) =>
                                handleChange('frequency-select', v)
                              }
                            />
                          </div>
                        )}
                      </div>
                    </ItemWrapper>
                  </Section>
                )}
              </div>
              {withoutCollapse && (
                <div className={css.right}>
                  <PreviewWrapper withoutCollapse={withoutCollapse} />
                </div>
              )}
            </div>
          </GeneralCollapseContent>
        }
        clickToExpand
        expandOffset={12}
        onClickTrigger={(s) => handleOpenCollapse(s)}
      />
    </GeneralCollapseWrapper>
  );
};

export default CollapseItem;
